// @ts-strict-ignore
import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  mainArea: {
    position: 'relative',
    zIndex: '2',
  },
  mainAreaWrapper: {
    position: 'relative',
  },
  subheader: {
    padding: 0,
  },
  subheaderSubtitle: {
    color: theme.palette.secondary.dark,
  },
  subheaderSubtitleSeparator: {
    display: 'inline-block',
    margin: theme.spacing(0, 1),
    '&::before': {
      content: '"·"',
    },
  },
  buttons: {
    padding: theme.spacing(0, 4, 4, 4),
    '& > *': {
      marginRight: `${theme.spacing(2)} !important`,
    },
  },
  buttonIcon: {
    marginLeft: `${theme.spacing(2)} !important`,
  },
  positionTypes: {
    '&:first-letter': {
      textTransform: 'capitalize',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(3),
    marginTop: theme.spacing(10),
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
  },
  splashSidebar: {
    '& > *': {
      animation: `${keyframes`
        0% {
          transform: scale(0),
          opacity: 0,
        }
        100% {
          transform: scale(1),
          opacity: 1,
        }
      `} 1.5s backwards`,
      transformOrigin: 'center left',
      '&:nth-of-type(1)': {
        animationSelay: '1.2s',
      },
      '&:nth-of-type(2)': {
        animationSelay: '1.3s',
      },
      '&:nth-of-type(3)': {
        animationSelay: '1.4s',
      },
    },
  },
  sidebar: {
    position: 'absolute',
    marginTop: theme.spacing(-6),
    left: '100%',
    top: '200px',
    width: 'calc(50vw - 500px)',
    boxSizing: 'border-box',
    padding: theme.spacing(4),
  },
  internals: {
    padding: theme.spacing(2),
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8, 12),
    },
  },
}))
